export default {
    buttonText: "Download App",
    defaultMobileURL: "https://mndy.onelink.me/jkGO",
    defaultDesktopURL: "/"
};
